/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @returns {object}          The parsed JSON, status from the response
 */
function parseJSON(response) {
    return new Promise((resolve, reject) => {
        response.json()
            .then(json => resolve({
                status: response.status,
                ok: response.ok,
                json,
            }))
            .catch(error => reject({
                status: response.status,
                ok: response.ok,
                json: {
                    error: error.name,
                    message: error.message,
                },
            }));
    });
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @returns {Promise}           The request promise
 */
export default function request(url, options) {
    return new Promise((resolve, reject) => {
        fetch(url, options)
            .then(parseJSON)
            .then((response) => {
                if (response.ok) {
                    return resolve(response.json);
                }
                return reject(response.json);
            })
            .catch(error => reject({
                response: error,
            }));
    });
}
